export const BookingNotAcceptedByDriver = 'BookingNotAcceptedByDriver'
export const MissingPocPod = 'MissingPocPod'
export const CollectionDeliveryDelay = 'CollectionDeliveryDelay'
export const DriverOnboard = 'DriverOnboard'
export const EtaProvider = 'ETAProvider'